import { Component, OnInit, Output, Input, EventEmitter, ViewEncapsulation } from '@angular/core';
import { DoughnutChart } from '../../models/chart';

@Component({
  selector: 'app-donut-tabs',
  templateUrl: './donut-tabs.component.html',
  styleUrls: ['./donut-tabs.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DonutTabsComponent implements OnInit {
  @Output() onSelect = new EventEmitter();
  @Input() details: DoughnutChart[] = [];
  @Output() candSelect = new EventEmitter();
  @Input() source: boolean;

  constructor() {}

  ngOnInit() {
    //console.log('tabs');
    console.log('------>', this.details);
    this.source = true;
  }

  onTabChanged(event) {
    console.log(event.tab.textLabel);
    this.onSelect.emit(event.tab.textLabel);
  }

  // getCandidateID from mat-table-with-chip compoenet
  getCandidateID(cand) {
    console.log('e-->', cand);
    this.candSelect.emit(cand);
  }
}
